import { makeStyles } from "@mui/styles";

const AppRadioButtonStyles = makeStyles(() => {
  // Base styles that can be reused
  const formControlLabelStyles = {
    border: "2px solid #b8b8b8",
    padding: 0,
    margin: 0,
    width: "fit-content",
    minWidth: "10rem",
    borderRadius: "0.3rem",
    backgroundColor: "#f9ca01",
  };

  const formLabelStyles = {
    color: "black",
  };

  const formGroupStyles = {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    gap: "1rem",
  };

  return {
    default: () => ({}),
    separated: () => ({
      "& .MuiFormControlLabel-root": formControlLabelStyles,
      "& .MuiFormLabel-root": formLabelStyles,
      "& .MuiFormGroup-root": formGroupStyles,
    }),
  };
});

export { AppRadioButtonStyles };
